import React from 'react';
import PropTypes from 'prop-types';
import autobind from "autobind-decorator";

import services from 'core/services';
import { PureComponent } from 'core/components';
import { Swiper, SwiperSlide, Button } from 'core/components/Framework7';

import classes from './styles.module.css';

class SliderComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.router = this.$f7.views.current && this.$f7.views.current.router
    
    this.state = {

    };
  };

  /**
   * @inheritdoc
   */
  static get defaultProps() {
    return {
      autoplay: false,
      loop: true,
      lazy: true,
      pagination: true,
      navigation: false,
      scrollbar: false,
      items: [],
      height: null,
      ratio: "100%",
    };
  };

  get initialValue() {
    return this.parseSliderItems
  }

  /**
   * parse items for show in slider
   * @param {Array} items 
   */
  parseSliderItems() {
    const { items } = this.props;

    return items.map(item => {
      return this.parseSliderItem(item)
    })
  }

  /**
   * parse item of slider
   * @param {Object} item 
   */
  parseSliderItem(item) {
    return {
      id: item.id,
      alt: item.category ? item.category.cover ? item.category.cover.title : null : null,
      url: item.category ? item.category.cover ? services.utils.url.image(item.category.cover, 6) : null : null,
      srcSet: item.category ? item.category.cover ? services.utils.imageSourceSizes.srcSet(item.category.cover.url) : [] : [],
      childrenType: item.childrenType
    }
  }

  changeRoute(item) {
    if (!this.props.navigate) return

    if (!item.childrenType || item.childrenType === '') return

    if (item.childrenType) {
      // this.props.navigate.navigate(`/node/${item.id}`, { props: { navigate: this.props.navigate } })
      this.router && this.router.navigate(`/node/${item.id}`)
    }
  }

  /**
   * render swiper items
   */
  renderSwiperSlider() {
    const items = this.initialValue();

    return items.map(item => {
      return (
        <SwiperSlide
          key={item.id}
          className={classes.slide}
        >
          <img alt={item.alt}
            src={item.url}
            srcSet={item.srcSet}
            sizes="100vw"
            onClick={() => this.changeRoute(item)}
          />
        </SwiperSlide>
      );
    });
  };

  render() {
    const { autoplay, loop, lazy, pagination, navigation, scrollbar, height, ratio, items } = this.props;

    return (
      <div style={{ paddingTop: ratio, position: "relative" }}>
        <Swiper
          params={{
            autoplay: autoplay,
            loop: loop && items.length > 1,
            lazy,
          }}
          pagination={items.length > 1 && pagination}
          navigation={navigation}
          scrollbar={scrollbar}
          style={{ height: height || 'auto' }}
          className={classes.swiper}
        >
          {this.renderSwiperSlider()}
        </Swiper>
      </div>
    );
  };
};

SliderComponent.propTypes = {
  items: PropTypes.array,
  autoplay: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  loop: PropTypes.bool,
  pagination: PropTypes.bool,
  navigation: PropTypes.bool,
  lazy: PropTypes.bool,
  ratio: PropTypes.string,
};

export default autobind(SliderComponent);
